"use strict";
import { useUnitagsAddressQuery } from "data/apiClients/unitagsApi/useUnitagsAddressQuery";
import { useUnitagsUsernameQuery } from "data/apiClients/unitagsApi/useUnitagsUsernameQuery";
export const useUnitagByAddress = (address) => {
  const { data, isLoading, isPending, isFetching } = useUnitagsAddressQuery({
    params: address ? { address } : void 0
  });
  return { unitag: data, loading: isLoading, pending: isPending, fetching: isFetching };
};
export const useUnitagByName = (username) => {
  const { data, isLoading } = useUnitagsUsernameQuery({ params: username ? { username } : void 0 });
  return { unitag: data, loading: isLoading };
};
